import NumpadInputButton from './numpad-input-button'

export default NumpadInputButton
